import { Stack } from "@chakra-ui/react";
import { SourcingEventV2Dto } from "../../../autogen/bff-api";
import { AboutSection } from "./AboutSection";
import { ClassificationSection } from "./ClassificationSection";
import { ContractSection } from "./ContractSection";
import { CriteriaSection } from "./CriteriaSection";
import { DocumentsSection } from "./DocumentsSection";
import { PublicationsSection } from "./PublicationsSection";
import { ChangeNoticeSection } from "./changes/ChangeNoticeSection";

interface Props {
  event: SourcingEventV2Dto;
}

export const RequestTab = ({ event }: Props) => {
  const { eventData, publicContext } = event;
  return (
    <Stack spacing="5">
      <ChangeNoticeSection event={event} />
      <AboutSection eventData={eventData} />
      <ClassificationSection publicContext={publicContext} />
      <CriteriaSection eventData={eventData} />
      <ContractSection eventData={eventData} publicContext={publicContext} />
      <DocumentsSection documents={eventData.documents ?? []} />
      <PublicationsSection publications={publicContext.publications ?? []} />
    </Stack>
  );
};
